export default __webpack_public_path__ + "static/genesys-647d83568c778b0587c91c9244175386.png";